module.exports = __webpack_public_path__ + "static/media/logo.931d09cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 6
// module chunks = 0